module.exports = __webpack_public_path__ + "static/img/shareImg.c857fe83.png";